import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_ME_URL } from "../constants"
import { IErrorResponse, TUserLimits } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function getUserLimits(token: string | null) {
  const response = await axios(`${API_ME_URL}/limits`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useGetUserLimits = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<TUserLimits, IErrorResponse>({
    queryKey: ["user-limits-info-data"],
    queryFn: () => getUserLimits(token),
    refetchOnWindowFocus: false,
    enabled: Boolean(token),
  })
}
